var map = {
	"./bokeh1.jpg": 27748,
	"./bokeh2.jpg": 79379,
	"./pattern1.png": 95203,
	"./pattern10.png": 14379,
	"./pattern11.png": 1493,
	"./pattern12.png": 6809,
	"./pattern2.png": 9928,
	"./pattern3.png": 7793,
	"./pattern4.png": 66782,
	"./pattern5.png": 85095,
	"./pattern6.png": 65036,
	"./pattern7.png": 34133,
	"./pattern8.png": 4978,
	"./pattern9.png": 2843,
	"./photo1.jpg": 11449,
	"./photo2.jpg": 12782,
	"./photo3.jpg": 8619,
	"./photo4.jpg": 5016,
	"./photo5.jpg": 49845,
	"./photo6.jpg": 25706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54663;